module.exports = __webpack_public_path__ + "img/index-11.6b2b452b.png";